import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import { studentGroupsAPI } from '../services/api';
import './StudentGroupPicker.css';

const StudentGroupPicker = ({
    selectedGroupIds = [],
    onChange,
    className = ''
}) => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadGroups = async () => {
            try {
                setLoading(true);
                const res = await studentGroupsAPI.getGroups();
                setGroups(res.data.groups || []);
            } catch (error) {
                console.error('Ошибка загрузки групп:', error);
            } finally {
                setLoading(false);
            }
        };
        loadGroups();
    }, []);

    const toggleGroup = (groupId) => {
        const id = Number(groupId);
        const next = selectedGroupIds.includes(id)
            ? selectedGroupIds.filter(g => g !== id)
            : [...selectedGroupIds, id];
        onChange(next);
    };

    if (loading) {
        return <p className="group-picker-empty">Загрузка групп...</p>;
    }

    if (groups.length === 0) {
        return (
            <p className="group-picker-empty">
                Групп пока нет.{' '}
                <Link to="/admin/student-groups">Создать группу</Link>
            </p>
        );
    }

    return (
        <div className={`group-picker ${className}`}>
            <div className="group-picker-header">
                <FiUsers />
                <span>Группы ({selectedGroupIds.length} выбрано)</span>
            </div>
            <div className="group-picker-grid">
                {groups.map(group => (
                    <label
                        key={group.id}
                        className={`group-picker-item ${selectedGroupIds.includes(group.id) ? 'selected' : ''}`}
                    >
                        <input
                            type="checkbox"
                            checked={selectedGroupIds.includes(group.id)}
                            onChange={() => toggleGroup(group.id)}
                        />
                        <span className="group-picker-name">{group.name}</span>
                        <span className="group-picker-count">{group.members_count || 0} уч.</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default StudentGroupPicker;
